import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

function Home() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div
      className="mx-auto my-9 md:my-0 lg:w-[80%] md:w-[85%] w-[80%] md:h-screen h-full flex items-center justify-center"
      data-aos="fade-left"
      data-aos-easing="ease-in-sine"
      data-aos-duration="300">
      <div className="w-full lg:h-4/6 md:h-4/6 h-full grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-3  text-white lg:text-3xl md:text-2xl sm:text-xl text-xl font-poor-story">
        {/* NAME */}
        <div
          className="bg-gray lg:col-span-2 md:col-span-1 sm:col-span-1 col-span-1 lg:row-span-3 row-span-1 rounded-xl h-full flex flex-col gap-4 justify-center p-[5%] uppercase tracking-wide shadow-md hover:contrast-200"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-duration="400">
          <h1>fatma mohamed</h1>
          <h1>frontend developer</h1>
        </div>

        {/* ABOUT */}
        <div
          className="bg-blue row-span-3 col-span-1 rounded-xl h-full flex flex-col gap-4 justify-center text-white px-[5%] py-8 uppercase  tracking-wider relative shadow-md"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-duration="500">
          <h1>about</h1>
          <Link className="" to="/about">
            <img
              alt="icon"
              src={require("../assets/icons/arrow.png")}
              className="w-10 absolute bottom-2 right-[10px] hover:motion-safe:animate-bounce cursor-pointer"
            />
          </Link>
        </div>

        {/* SKILLS */}
        <div
          className="bg-orange row-span-3 lg:row-span-2 rounded-xl h-full flex flex-col gap-4 justify-center text-white px-[5%] py-8 uppercase  tracking-wider relative shadow-md"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-duration="600">
          <h1 className="mb-[10px]">skills</h1>
          <Link className="" to="/skills">
            <img
              alt="icon"
              src={require("../assets/icons/arrow.png")}
              className="w-10 absolute bottom-2 right-[10px] hover:motion-safe:animate-bounce cursor-pointer"
            />
          </Link>
        </div>

        {/* AVATAR */}
        <div
          className="lg:row-span-4 row-span-1 row-start-1 sm:col-span-1 rounded-xl h-full shadow-md"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000">
          <img
            alt="avatar"
            src={require("../assets/avatar/avatar.jpg")}
            className="w-full h-full rounded-xl"
          />
        </div>

        {/* PROJECTS */}
        <div
          className="bg-blue row-span-3 rounded-xl h-full flex flex-col gap-4 justify-center text-white px-[5%] py-8 uppercase  tracking-wider relative shadow-md"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-duration="700">
          <h1 className="mb-[10px]">projects</h1>
          <Link className="" to="/projects">
            <img
              alt="icon"
              src={require("../assets/icons/arrow.png")}
              className="w-10 absolute bottom-2 right-[10px] hover:motion-safe:animate-bounce cursor-pointer"
            />
          </Link>
        </div>

        {/* EDUCATION */}
        <div
          className="bg-gray row-span-3 rounded-xl h-full flex flex-col gap-4 justify-center text-white px-[5%] py-8 uppercase  tracking-wider relative shadow-md"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-duration="800">
          <h1 className="mb-[10px]">education</h1>
          <Link className="" to="/education">
            <img
              alt="icon"
              src={require("../assets/icons/arrow.png")}
              className="w-10 absolute bottom-2 right-[10px] hover:motion-safe:animate-bounce cursor-pointer"
            />
          </Link>
        </div>

        {/* RESUME */}
        <div
          className="bg-blue row-span-3 rounded-xl h-full flex flex-col gap-4 justify-center text-white px-[5%] py-8 uppercase  tracking-wider relative shadow-md"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-duration="900">
          <h1 className="mb-[10px]">resume</h1>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://drive.google.com/file/d/1GmylxhN8bsGFXMHpSL8_ngUxNbPWiBR_/view?usp=sharing">
            <img
              alt="icon"
              src={require("../assets/icons/arrow.png")}
              className="w-10 absolute bottom-2 right-[10px] hover:motion-safe:animate-bounce cursor-pointer"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
